import React, { useState, useEffect } from 'react';
import { Dialog, Box, Typography, ListItem, IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Close } from '@material-ui/icons';
import { useTranslate, useDataProvider } from 'react-admin';
import IconButtonCustom from '../button/icon-button';
import SelectBox from '../../CustomizedUIs/CustomSelectBox';
import { generateRandomString } from '../../utils';
import { changeInfoPageDirtyStatus, changeTreeData } from '../../redux/actions/tree-action';
import { useDispatch, useSelector } from 'react-redux';
import { cloneDeep } from 'lodash';
import CloseButton from '../../CustomizedUIs/CloseButton';

const useStyles = makeStyles(theme => ({
    dialogCloseBtn: {
        backgroundColor: theme.palette.common.white,
        marginLeft: 10
    },
    textLabel: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.85,
        letterSpacing: '0.13px',
        color: ' #88898c',
    },
    TexTSelect: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '24px',
        letterSpacing: '0.13px',
        color: '#4f5064',
    },
}));

function DialogCreateLanguage({ open, onClose }) {
    const classes = useStyles();
    const translate = useTranslate();
    const dataProvider = useDataProvider();
    const [openType, setOpenType] = useState(false);
    const [language, setLanguage] = useState(null);
    const [existedLangs, setExistedLangs] = useState([]);
    const [languages, setLanguages] = useState([]);
    const { tree, selectedInfoPageLang } = useSelector(state => state.tree);
    const dispatch = useDispatch();

    const handleClickOpenType = () => {
        setOpenType(!openType)
    }

    const onChange = (value) => {
        setLanguage(value)
        setOpenType(false)
    }

    const getListExistedLanguage = () => {
        const listExistedLanguages = [];
        for (let i = 0; i < languages.length; i++) {
            if (tree.find(item => item.language.id === languages[i].id) === undefined) {
                listExistedLanguages.push(languages[i]);
            }
        }
        setExistedLangs(listExistedLanguages);
    }

    const handleAddLanguage = () => {
        const data = {
            active: false,
            children: [
                {
                    children: [],
                    data: {
                        backgroundImage: null,
                        dyslexie: false,
                        formatDateTime: "",
                        instructionFeatureImage: null,
                        instructionVideo: null,
                        logoType: null,
                        rssLink: "",
                        textSize: "Medium",
                        formatDateTime: "",
                        weather: ""
                    },
                    expand: false,
                    id: "main_" + generateRandomString(5),
                    isShowNameInput: false,
                    nodeName: "Main",
                }
            ],
            expand: false,
            id: `lang_${language.id}`,
            isShowNameInput: false,
            language: language,
            expandIds: []
        }
        tree.push(data)
        dispatch(changeTreeData(tree));
        dispatch(changeInfoPageDirtyStatus(true));
        handleClose();
    }

    const handleCopyLanguage = () => {
        const data = cloneDeep(selectedInfoPageLang)
        data.active = false
        data.expand = false
        data.expandIds = [];
        data.id = `lang_${language.id}`
        data.isShowNameInput = false
        data.language = language
        data.children[0].expand = false
        data.children[0].id = 'main_' + generateRandomString(5)
        data.children[0].isShowNameInput = false
        data.children[0].nodeName = "Main"
        const recursiveChangeId = (array = [], id = Number) => {
            array.id = generateRandomString(5)
            array.parentMenu = id.includes('main_') ? null : id
            if (array.children)
                for (let j = 0; j < array.children.length; j++) {
                    recursiveChangeId(array.children[j], array.id)
                }
        }
        if (data.children[0].children)
            for (let i = 0; i < data.children[0].children.length; i++) {
                recursiveChangeId(data.children[0].children[i], data.children[0].id)
            }
        tree.push(data)
        dispatch(changeTreeData(tree));
        dispatch(changeInfoPageDirtyStatus(true));
        handleClose()
    }

    const getLanguageSupported = () => {
        dataProvider('GET_LIST', 'language', {
            sort: { field: 'createdAt', order: 'DESC' },
            pagination: { page: 1, perPage: 100 },
            filter: {}
        }).then(({ data }) => {
            setLanguages(data);
        }).catch((error) => console.error('getLanguageSupported:', error));
    }

    const handleClose = () => {
        onClose();
        setLanguage(null);
    }

    useEffect(() => {
        getLanguageSupported();
    }, []);

    return (
        <Dialog onEntering={getListExistedLanguage} open={open} onClose={handleClose} aria-labelledby="form-dialog-title" >
            <Box width={400} textAlign='center'>
                <Box display='flex' justifyContent='flex-end' alignItems='center' mr={2} mt={1}>
                    <Typography variant='subtitle2'>{translate(`pos.user.close`)}</Typography>
                    <CloseButton onClick={handleClose}/>
                </Box>
                <Box display='flex' justifyContent='center' width='100%' mt={2}>
                    <Box style={{ width: 300 }}>
                        <SelectBox
                            label={translate('pos.common.language')}
                            value={language ?
                                <Box display='flex' alignItems='center' style={{ marginTop: '-5px' }} >
                                    <img src={"https://www.countryflags.io/" + language.code + "/flat/32.png"} />
                                    <Box className={classes.TexTSelect} ml={2}>{language.name}</Box>
                                </Box> : ''}
                            open={openType}
                            handleClick={handleClickOpenType}
                        >
                            <Box className={classes.boxBoder}>
                                {
                                    existedLangs.map(item => (
                                        <ListItem key={item.id + ''} style={{ padding: '8px' }} onClick={() => onChange(item)} button >
                                            <Box display='flex' alignItems='center'>
                                                <img src={"https://www.countryflags.io/" + item.code + "/flat/32.png"} />
                                                <Typography className={classes.TexTSelect} style={{ marginLeft: '16px' }}>{item.name}</Typography>
                                            </Box>
                                        </ListItem>
                                    ))
                                }
                            </Box>
                        </SelectBox>
                    </Box>
                </Box>
                <Box display='flex' justifyContent='center' width='100%' mt={2} mb={2}>
                    <IconButtonCustom
                        disabled={!language}
                        label={translate('pos.common.add')}
                        onClick={handleAddLanguage}
                        style={{ marginRight: 10 }}
                    />
                    <IconButtonCustom
                        disabled={!language}
                        label={translate('pos.common.copy')}
                        onClick={handleCopyLanguage}
                    />
                </Box>
            </Box>
        </Dialog>
    );
}

export default DialogCreateLanguage;
